import { useEffect, useRef } from 'react';

interface Options {
  onScan: (barcode: string) => void;
  minLength?: number;
  timeLimit?: number;
}

export default function useBarcodeScanner({ 
  onScan, 
  minLength = 3, 
  timeLimit = 10000 // Change this to 1000 when integrated with hardware 
}: Options) {
  const buffer = useRef<string>('');
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      const target = e.target as HTMLElement;
      if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') {
        return;
      }

      if (e.key === 'Enter') {
        if (buffer.current.length >= minLength) {
          onScan(buffer.current);
          buffer.current = '';
          if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }
        return;
      }

      if (e.key.length !== 1) return;

      buffer.current += e.key;

      if (timeoutRef.current) clearTimeout(timeoutRef.current);

      timeoutRef.current = setTimeout(() => {
        buffer.current = '';
      }, timeLimit);
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [onScan, minLength, timeLimit]);
}
